import GenericModel from 'js/models/generic.model';
import _ from 'underscore';
import i18n from 'l10n';
require('moment');

    export default GenericModel.extend({
        urlRoot: '/CampaignCloud/Config',
        idAttribute: 'id',
        defaults: {
            title: "",
            startDate: null,
            contactIds: [],
            includedGroups: [],
            excludedGroups: ["Group1"],
            message: "",
            contentForUniqueCode: null,
            urlForUniqueCode: null,
            campaignTemplateType: "BULK"
        },
        initialize: function() {
            if(this.get('campaignTemplateType') == 'BULK') {
                let campaignChannel = this.get('campaignChannel');
                if(campaignChannel == 'SMS' || campaignChannel == 'EMAIL') {
                    if(this.get('excludedGroups')) {
                        let token = campaignChannel + (campaignChannel == 'EMAIL' ? 'S' : '');
                        this.get('excludedGroups').push(`GroupBOUNCED ${token}`);
                    }
                }
            }

            this.setUpChangeListener("startDate");
        },
        batchUpdate: function() {
            return $.ajaxDefaultQ({
                url: this.url(),
                type: 'PATCH',
                contentType: 'application/json',
                data: JSON.stringify(this.changed),
                dataType: 'json'
            }).then(response => {
                const successful = _.filter(response, item => item.outcome === "OK");
                const errorCount = response.length - successful.length;
                _.each(successful, ({outcome, data}) => {
                    const {attributeName} = data;
                    this.syncAttribute(attributeName);
                });
                if (errorCount === 0) {
                    this.trigger('sync', this);
                    $.Notify.show(i18n.t("service.configsaved"));
                } else {
                    $.Notify.show(i18n.t("service.confignotsaved", {count:errorCount}));
                }
            });
        },
        setUpChangeListener: function (attr) {
            this.on(`change:${attr}`, () => {
                _.forEach(this.changed, (val, key) => {
                    this.changed[`${attr}`] = val;
                });

                this.trigger('change', this.get(`${attr}`));
            });
        }
    });
